export default "https://cdn-static.gokick.com/assets/a922e5568f1cf4039f8565ae5776ec3d05b76040/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";